import { Check } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface BillPurchaseSuccessProps {
  title: string;
  message: ReactNode;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

const BillPurchaseSuccess = ({
  title,
  message,
  primaryLabel = "Return to Dashboard",
  primaryTo = "/home",
  secondaryLabel = "View Transactions",
  secondaryTo = "/payments/history",
}: BillPurchaseSuccessProps) => {
  return (
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      exit={{ y: "100%" }}
      transition={{
        type: "tween",
        ease: "anticipate",
      }}
      className="fixed inset-0 z-50 flex items-center justify-center gap-10 px-5 py-20 text-center flex-col bg-white"
    >
      <div className="max-w-2xl flex flex-col items-center justify-center gap-8">
        <div className="bg-green-500 rounded-full p-8 text-white shadow-lg shadow-green-500/20">
          <Check size={36} weight="bold" />
        </div>
        <div className="text-center flex flex-col gap-2">
          <div className="text-3xl font-medium">{title}</div>
          <div className="text-gray-700">{message}</div>
        </div>
        <div className="flex flex-wrap items-center gap-4 justify-center">
          <Link
            to={primaryTo}
            className="p-3 px-6 text-center bg-deepBlue text-white rounded-xl font-medium"
          >
            {primaryLabel}
          </Link>
          <Link
            to={secondaryTo}
            className="p-3 px-6 text-center bg-white text-deepBlue border rounded-xl font-medium"
          >
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default BillPurchaseSuccess;
